export default __webpack_public_path__ + "static/media/english.397a8768.svg";